import GlassesPrescriptionConfig from "@/views/configs/glasses_prescription/index.vue";

export default [
  {
    path: "receitas-oculos",
    name: "Configuração Receitas de óculos",
    component: GlassesPrescriptionConfig,
  },
];
